import { defineNuxtRouteMiddleware } from '#imports'
import { asRouteMiddleware, redirectHomeIfLoggedIn } from '@router/route-guards'

export default defineNuxtRouteMiddleware(asRouteMiddleware(redirectHomeIfLoggedIn))
